import * as React from "react";
import { Block } from "baseui/block";
import { Breakpoints, useStyletron } from "baseui/styles";
import { Button, KIND, SHAPE } from "baseui/button";
import { Header } from "kanopi-components/Layout/Header";
import { HorizontalSpacer } from "kanopi-components/SpaceWrapper/HorizontalSpacer";
import { Icon } from "../icons/Icon";
import { Logo } from "kanopi-components/Logo";
import { NavItemProps } from "baseui/side-navigation";
import { SidePadder } from "kanopi-components/Layout";
import { SIZE } from "baseui/input";
import { VerticalSpacer } from "kanopi-components/SpaceWrapper/VerticalSpacer";

type LeftNavHeaderProps = {
  title: string;
  logoSrc?: string;
  logoAltText?: string;
  color?: string;
  backgroundColor?: string;
  hoverBackgroundColor?: string;
  hoverTextColor?: string;
  mainItems?: NavItemProps[];
  userItems?: NavItemProps[];
  onOpenCloseToggle?: () => void;
  open?: boolean;
  kind?: keyof Breakpoints;
};
export const LeftNavHeader: React.FC<LeftNavHeaderProps> = (props) => {
  const [, theme] = useStyletron();
  const {
    title,
    logoSrc,
    logoAltText,
    color,
    open,
    kind = "large",
    hoverBackgroundColor,
    hoverTextColor,
    onOpenCloseToggle,
    mainItems = [],
    userItems = [],
  } = props;

  const menuToggle = (
    <Button
      data-testid="sidebarOpenCloseButton"
      onClick={onOpenCloseToggle}
      shape={SHAPE.square}
      size={SIZE.mini}
      kind={KIND.tertiary}
      aria-label="Toggle menu"
      aria-expanded={open ? "true" : "false"}
      overrides={{
        BaseButton: {
          style: {
            width: "auto",
            ":hover": {
              backgroundColor: hoverBackgroundColor,
              color: hoverTextColor,
            },
          },
        },
      }}
    >
      <Icon icon="menu" color={color} />
    </Button>
  );
  const smallHeader = (
    <SidePadder>
      <Block
        paddingTop={theme.sizing.scale800}
        paddingBottom={theme.sizing.scale800}
        width="100%"
      >
        <HorizontalSpacer justifyContent="space-between">
          {menuToggle}
          <Header
            userName={title}
            mainItems={mainItems}
            userItems={userItems}
            height="unset"
          />
        </HorizontalSpacer>
      </Block>
    </SidePadder>
  );
  return kind === "small" ? (
    smallHeader
  ) : open ? (
    <VerticalSpacer gap="inner-section">
      {menuToggle}
      {open && <Logo src={logoSrc} altText={logoAltText} />}
    </VerticalSpacer>
  ) : (
    <HorizontalSpacer justifyContent="center">
      {menuToggle}
      {open && <Logo src={logoSrc} altText={logoAltText} />}
    </HorizontalSpacer>
  );
};
